import React from 'react';
import { Page, Text, View, Image, Font } from '@react-pdf/renderer';
import Header from './Header'; // Import header
import Footer from './Footer'; // Import footer
import styles from './PagesStyle/Page1Styles'; // Import styles from PagesStyle folder

Font.register({
  family: 'Roboto',
  fonts: [
    { src: require('./fonts/Roboto-Regular.ttf'), fontWeight: 'normal' },
    { src: require('./fonts/Roboto-Bold.ttf'), fontWeight: 'bold' },
    { src: require('./fonts/Roboto-Light.ttf'), fontWeight: 'light' },
    { src: require('./fonts/Roboto-Medium.ttf'), fontWeight: 'medium' },
  ],
});

const isValidChartImage = (image) => {
  return image && image.startsWith('data:image/png;base64,');
};


const formatMoney = (cost) => {
  if (cost === null || cost === undefined || isNaN(cost)) {
    return 'N/A';
  }

  const numberCost = Number(cost);
  // Check if the number has a fractional part
  const hasDecimals = numberCost % 1 !== 0;

  if (hasDecimals) {
    // If it has decimals, format with two decimal places
    return `$${numberCost.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  } else {
    // If no decimals, format without them
    return `$${numberCost.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
  }
};

const formatMoneyNoDecimals = (cost) => {
  if (cost === null || cost === undefined || isNaN(cost)) {
    return 'N/A';
  }
  return `$${Number(cost).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
};


const Page4 = ({ formData, chartImage, companyLogo }) => {
  // Function to determine which image to display based on grade
  const getBarImage = (grade) => {
    const numericGrade = parseFloat(grade); // Convert grade to a number

    if (numericGrade <= 1) {
      return '/imageBar1.png';
    } else if (numericGrade >= 2 && numericGrade < 3) {
      return '/imageBar2.png';
    } else if (numericGrade >= 3 && numericGrade < 4) {
      return '/imageBar3.png';
    } else if (numericGrade >= 4 && numericGrade < 5) {
      return '/imageBar4.png';
    } else if (numericGrade >= 5) {
      return '/imageBar5.png';
    } else {
      return '/Logo (1).png'; // Fallback image if no valid grade is found
    }
  };


  return (
    <Page size="LETTER" style={styles.pagePage4}>
      <Header formData={formData} companyLogo={companyLogo} />

      <View style={styles.parentContainerPage4}>
        {/* Left Column */}
        <View style={styles.leftContainerPage4}>
          <View style={styles.leftColumnPage4}>
            <View style={styles.LeftSectionPage4}>
              <Text style={[styles.TitleSectionPage4]}>DAMAGE ANALYSIS</Text>
              <View style={styles.TitleBottomBorderPage4} />

              <View style={styles.paddingSpacePage4}>
                <View style={styles.SquareTitlePage4}>
                  <Text style={styles.TitlePage4}>DAMAGE TO VALUE</Text>
                </View>
                <View style={styles.dataContainerPage4}>
                  <Text style={styles.textDataPage4}>{formData.damage_to_value ? `${formData.damage_to_value}%` : 'N/A'}</Text>
                </View>
              </View>

              <View style={styles.SquareTitlePage4}>
                <Text style={styles.TitlePage4}>DAMAGE SEVERITY SCORE & GRADE</Text>
              </View>

              <View style={styles.LeftSquarePage4}>
                <Text style={styles.TextSquarePage4}>
                  {formData.damageScore || 'N/A'}
                </Text>
              </View>

              <View style={styles.RightSquarePage4}>
                <Text style={styles.TextSquarePage4}>
                  {formData.grade || 'N/A'}
                </Text>
              </View>

              <View style={{ height: 60 }}>
                <View style={styles.BarImagePage4} >
                  <Image src={getBarImage(formData.grade)} />
                </View>
              </View>

              <View style={styles.dvsHeaderDiv}>
                <Text style={styles.TitleSectionPage4}>DIMINISHED VALUE SUMMARY</Text>
                <View style={styles.TitleBottomBorderPage4} />
              </View>

              
              <View style={styles.divPage4dvs}>
                <View style={styles.paddingSpacePage4}>
                  <View style={styles.SquareTitlePage4}>
                    <Text style={styles.TitlePage4}>PRE-LOSS FMV</Text>
                  </View>
                  <View style={styles.dataContainerPage4}>
                    <Text style={styles.textDataPage4}>{formatMoneyNoDecimals(formData.PreLossFMV) || '$N/A'}</Text>
                  </View>
                </View>

                <View style={styles.paddingSpacePage4}>
                  <View style={styles.SquareTitlePage4}>
                    <Text style={styles.TitlePage4}>MAXIMUM DV</Text>
                  </View>
                  <View style={styles.dataContainerPage4}>
                    <Text style={styles.textDataPage4}>{formatMoneyNoDecimals(formData.max_loss) || '$N/A'}</Text>
                  </View>
                </View>

                <View style={styles.paddingSpacePage4}>
                  <View style={styles.SquareTitlePage4}>
                    <Text style={styles.TitlePage4}>INHERENT DV</Text>
                  </View>
                  <View style={styles.dataContainerPage4}>
                    <Text style={styles.textDataPage4}>{formatMoneyNoDecimals(formData.inherentDV) || '$N/A'}</Text>
                  </View>
                </View>

                <View style={styles.paddingSpacePage4}>
                  <View style={styles.SquareTitlePage4}>
                    <Text style={styles.TitlePage4}>REPAIR RELATED DV</Text>
                  </View>
                  <View style={styles.dataContainerPage4}>
                    <Text style={styles.textDataPage4}>{'0'}</Text>
                  </View>
                </View>


                <View style={styles.paddingSpacePage4}>
                  <View style={styles.SquareTitlePage4}>
                    <Text style={styles.TitlePage4}>POST-REPAIR FMV</Text>
                  </View>
                  <View style={styles.dataContainerPage4}>
                    <Text style={styles.textDataPage4}>{formatMoneyNoDecimals(formData.postRepairFMV) || '$N/A'}</Text>
                  </View>
                </View>
              </View>

              {/*

              <View style={styles.containerFinalHigh}>
                <Text style={styles.finalHighValueText}>{formatMoneyNoDecimals(formData.final_high) || '$N/A'}</Text>
              </View>

              <View style={styles.containerFMV}>
                <Text style={styles.postRepairText}>{formatMoneyNoDecimals(formData.postRepairFMV) || '$N/A'}</Text>
              </View>

              <View style={styles.containerDiminishedValue}>
                <Text style={styles.diminishedValueText}>{formatMoneyNoDecimals(formData.diminishedValue) || '$N/A'}</Text>
              </View>

              */}

              <View style={styles.GraphImagePage4}>
                {isValidChartImage(chartImage) ? (
                  <Image
                    style={styles.graphInsideContainer}
                    src={{ uri: chartImage, method: 'GET', headers: {}, body: '' }}
                  />
                ) : (
                  <Image src="/error.webp" />
                )}
              </View>
            </View>
          </View>
        </View>



        {/* Right Column */}
        <View style={styles.rightContainerPage4}>
          <View style={{ top: 15 }}>
            <View style={styles.rightColumnPage4}>
              <Text style={[styles.paragraphPage4, { marginTop: 5 }]}>
                The damage amount as a percentage of the pre-accident value of the vehicle.{'\n'}
              </Text>
            </View>

            <View style={styles.TableImagePage4}>
              <Image style={styles.ImagePage4} src="/tableWithScore.png" />
            </View>


            <View style={{ top: 13 }}>
              <View style={styles.rightColumnPage4}>
                <Text style={styles.paragraphPage4}>
                  The amount offered in cash by a reasonable and willing{'\n'}
                  buyer immediately before the accident. This amount also{'\n'}
                  takes into consideration regional preferences and the overall appeal{'\n'}
                  of the subject vehicle. {'\n'}
                </Text>
              </View>

              <View style={[styles.rightColumnPage4, { top: 5 }]}>
                <Text style={styles.paragraphPage4}>
                  The most this vehicle can lose in value in the most severe{'\n'}
                  of accidents.
                </Text>
              </View>

              <View style={[styles.rightColumnPage4, { top: 16 }]}>
                <Text style={styles.paragraphPage4}>
                  The reduction in value associated with damage disclosure.{'\n'}
                  Even with perfect, undetectable repairs, the market rating{'\n'}
                  on this vehicle is downgraded.{'\n'}{'\n'}
                </Text>
              </View>

              <View style={[styles.rightColumnPage4, { top: 13 }]}>
                <Text style={styles.paragraphPage4}>
                  The amount offered in cash by a reasonable and willing{'\n'}
                  buyer after the disclosure of a prior loss or improper repairs. {'\n'}{'\n'}{'\n'}
                </Text>
              </View>

              <View style={[styles.rightColumnPage4, { top: 12 }]}>
                <Text style={styles.paragraphPage4}>
                  The amount offered in cash by a reasonable and willing{'\n'}
                  buyer after the disclosure of a prior loss or improper repairs.
                </Text>
              </View>
            </View>

            <View style={{ top: 70, left: 25 }}>
              <View style={{ alignSelf: 'center' }}>
                <View style={styles.SquareTotalDiminishedValuePage4}>
                  <Text style={styles.TextSquareDimishedValuePage4}>
                    TOTAL DIMINISHED VALUE
                  </Text>
                </View>

                <View style={styles.SquarePricePage4}>
                  <Text style={styles.ValueSquarePricePage4}>
                    {formatMoneyNoDecimals(formData.diminishedValue) || '$N/A'}
                  </Text>
                </View>
              </View>

              <View style={styles.containerFinalPercentagePage4}>
                <Text style={styles.finalPercentagePage4}>
                  {formData.inherentDV && formData.PreLossFMV
                    ? `${((formData.inherentDV / formData.PreLossFMV) * 100).toFixed(2)}%`
                    : 'N/A%'}
                </Text>
              </View>
            </View>
          </View>



        </View>


      </View>

      <Footer />
    </Page>
  );
};

export default Page4;